import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../../../../../common/Button";

const MoreVariable = () => {

  const keypad = useSelector( state => state.keypad );

  return (
    <div className="more_key">
      <table className="key_tbl" summary="키패드">
        <tbody>
        <tr>
          <td><Button className={ '0' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="0" more-key-latex="x"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_x.svg` } alt="" /></Button></td>
          <td><Button className={ '1' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="1" more-key-latex="y"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_y.svg` } alt="" /></Button></td>
          <td><Button className={ '2' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="2" more-key-latex="z"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_z.svg` } alt="" /></Button></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default MoreVariable;
